import { createSelector } from 'reselect';

const getAuthId = (state) => state.auth.id;
const getAccountList = (state) => state.accounts.list;
const getActiveAccountId = (state) => state.accounts.active;
const getAttendees = (state) => state.actorView.access;
const getOwnerId = (state) => state.actorView.userId;
const getReadOnly = (state) => state.actorView.readonly;
const getPrivs = (state) => state.actorView.privs;

export const getActiveAccountOwnerId = createSelector(
  [getAccountList, getActiveAccountId],
  (list, active) => list.find((i) => i.id === active).ownerId
);

export const getActiveAccount = createSelector(
  [getAccountList, getActiveAccountId],
  (list, active) => list.find((i) => i.id === active)
);

export const getCanEditActor = createSelector(
  [getReadOnly, getPrivs],
  (readOnly, privs) => !readOnly && privs && privs.modify
);

export const getCanEditActorAttendees = createSelector(
  [getReadOnly, getPrivs],
  (readOnly, privs) => privs && privs.modify
);

export const getIsActorOwner = createSelector(
  [getOwnerId, getAuthId],
  (ownerId, authId) => ownerId === authId
);

export const getActorSigners = createSelector([getAttendees], (attendees) =>
  attendees.filter((i) => i.privs.sign)
);
